import * as React from 'react'
import { NavDropdown } from 'react-bootstrap'
import ApiCall from '../../../../components/ApiCall/ApiCall'
/*
    this class is the drop -down button you can find in the header after being logged to our website
*/
interface LoggedProps {
}

interface LoggedState {

}

export default class LoggedButton extends React.Component<LoggedProps, LoggedState> {

    private api = new ApiCall()

    constructor (props: LoggedProps) {
        super(props)
        this.state = {

        }

    }


    render () {
        return (
        <>
			<NavDropdown  title={<i className="fa fa-user fa-fw"></i>} id="basic-nav-dropdown" >
                <NavDropdown.Item href="settings">Mes Informations</NavDropdown.Item>
                <NavDropdown.Item href="settingspassword">Modification de mot de passe</NavDropdown.Item>
                <NavDropdown.Item href="historique">Votre historique</NavDropdown.Item>
                <NavDropdown.Item href="aide">Vous voulez nous aider ?</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={this.Deconnexion} href='/accueil'>Déconnexion <i className="fas fa-sign-out-alt"></i></NavDropdown.Item>
            </NavDropdown>
        </>
        );
    }


    Deconnexion = async() => {
        localStorage.clear();
    } 
}